import { ButtonBase, Typography } from '@mui/material'
import {
  getDocumentExtensionLabel,
  getDocumentIconTone,
  getDocumentTypeIcon,
} from '@/pages/Documents/documentItemMeta'
import styles from './index.module.scss'

/**
 * @param {{
 *   item: import('@/pages/Documents/documentsDemoData').DocumentItem,
 *   onSelect: () => void,
 *   disabled?: boolean,
 * }} props
 */
export default function AiAskBarRecentDocumentChip({ item, onSelect, disabled = false }) {
  const Icon = getDocumentTypeIcon(item.category)
  const tone = getDocumentIconTone(item.category)
  const extensionLabel = getDocumentExtensionLabel(item.name)

  return (
    <ButtonBase
      type="button"
      className={styles.recentDocumentChip}
      onClick={onSelect}
      disabled={disabled}
      aria-label={`Attach ${item.name}`}
    >
      <span className={`${styles.recentDocumentIconWrap} ${styles[`recentDocumentIconWrap_${tone}`]}`} aria-hidden>
        <Icon className={styles.recentDocumentIcon} />
      </span>
      <span className={styles.recentDocumentMeta}>
        <Typography component="span" className={styles.recentDocumentName}>
          {item.name}
        </Typography>
        <Typography component="span" className={styles.recentDocumentSub}>
          {extensionLabel} · {item.sizeLabel}
        </Typography>
      </span>
    </ButtonBase>
  )
}
